export const usName = [
  '道琼斯',
  '纳斯达克',
  '标普500',
  '科技',
  '金融',
  '医疗',
  '能源',
  '消费',
  '工业'
];

export const hsName = [
  '上证指数',
  '深证成指',
  '创业板指',
  '个护用品',
  '跨境支付',
  '航天装备',
  '阿尔兹海默',
  '商业物业经营',
  '渔业'
];

export const hkName = [
  '恒生指数',
  '恒生科技',
  '国企指数',
  '科技',
  '金融',
  '地产',
  '消费',
  '医疗',
  '能源'
];
